import UserPayments from "../../Portal/Accessor/User/UserPayments";
import UserCredits from "../../Portal/Accessor/User/UserCredits";
import PurchaseCredits from "../../Portal/Accessor/User/PurchaseCredits";
import PaymentDetail from "../../Portal/Accessor/User/PaymentDetail";
import Profile from "../../Portal/Accessor/User/Profile";
import UserSimulationLogs from "../../Portal/Accessor/User/UserSimulationLogs";
import ChangePassword from "../../Portal/Accessor/User/ChangePassword";
import PaymentResult from "../../Portal/Accessor/User/PaymentResult";
import UserRefunds from "../../Portal/Accessor/User/UserRefunds";
import RefundDetail from "../../Portal/Accessor/User/RefundDetail";
import RefundResult from "../../Portal/Accessor/User/RefundResult";
import TermsAndConditions from "../../Portal/Accessor/Default/TermsAndConditions";
import ReleaseLogs from "../../Portal/Accessor/Default/ReleaseLogs";

const AccessorUserRouters = [
    {
        path: "/UserAssessor/ReleaseLogs",
        exact: true,
        requireAuth: false,
        element: <ReleaseLogs />,
        title: "Release Logs | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Credits",
        exact: true,
        requireAuth: true,
        element: <UserCredits />,
        title: "User Credits | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Payments",
        exact: true,
        requireAuth: true,
        element: <UserPayments />,
        title: "User Payments | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Credits/Purchase",
        exact: true,
        requireAuth: true,
        element: <PurchaseCredits />,
        title: "Purchase Credits | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Credits/Payment/:jsonParam",
        exact: true,
        requireAuth: true,
        element: <PaymentDetail />,
        title: "Payment Detail | AccuRate Enterprise",
    },
    {
        path: "UserAssessor/Credits/PaymentResult/:jsonParam",
        exact: true,
        requireAuth: true,
        element: <PaymentResult />,
        title: "Payment Result | AccuRate Enterprise",
    },
    {
        path: "UserAssessor/Profile",
        exact: true,
        requireAuth: true,
        element: <Profile />,
        title: "Profile | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/ChangePassword",
        exact: true,
        requireAuth: true,
        element: <ChangePassword />,
        title: "Change Password | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/SimulationLogs",
        exact: true,
        requireAuth: true,
        element: <UserSimulationLogs />,
        title: "User Simulation Logs | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Refunds",
        exact: true,
        requireAuth: true,
        element: <UserRefunds />,
        title: "User Refunds | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Credits/Refund/:creditId",
        exact: true,
        requireAuth: true,
        element: <RefundDetail />,
        title: "Refund | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/Credits/RefundResult/:jsonParam",
        exact: true,
        requireAuth: true,
        element: <RefundResult />,
        title: "Refund Result | AccuRate Enterprise",
    },
    {
        path: "/UserAssessor/TermsConditions",
        exact: true,
        requireAuth: true,
        element: <TermsAndConditions />,
        title: "Terms & Conditions | AccuRate Enterprise",
    }
  ];
  export default AccessorUserRouters;